import { toast } from "react-toastify";

export function thumbItemHasPath(item) {
  return typeof item?.path === "string" && item.path.trim() !== "";
}

function buildGameSlug(game) {
  const slugRaw = (
    game?.gameName ??
    game?.game_name ??
    game?.gameId ??
    game?.game_id ??
    "game"
  ).toString();
  return (
    slugRaw
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "") || "game"
  );
}

export function navigateToCasinoGameLaunch(navigate, game, options = {}, auth) {
  if (!auth?.token) {
    if (typeof window !== "undefined" && typeof window.openLoginDialog === "function") {
      window.openLoginDialog();
    } else {
      toast.error("Please login to continue.", {
        toastId: "casino_launch_login_required",
      });
    }
    return;
  }

  if (auth?.user?.is_demo || auth?.isDemoLogin) {
    toast.error("Demo users are not allowed to play casino games.", {
      toastId: "demo_casino_restricted",
    });
    return;
  }

  const { activeProviderCode, selectedSubCategory } = options;
  const slug = buildGameSlug(game);
  const resolvedGameId = String(
    game?.gameId ?? game?.game_id ?? game?.gameCode ?? game?.game_code ?? "",
  ).trim();
  const providerCode = (activeProviderCode || game?.providerName || game?.provider_name || "MAC88")
    .toString()
    .trim();

  const nextParams = new URLSearchParams();
  const categoryForLaunch = String(game?.category || selectedSubCategory || "Game Lobby");

  nextParams.set("gameId", resolvedGameId);
  nextParams.set("gameCode", String(game?.gameCode ?? game?.game_code ?? ""));
  nextParams.set("provider", String(game?.providerName ?? game?.provider_name ?? providerCode));
  nextParams.set("subProvider", String(game?.subProviderName ?? game?.sub_provider_name ?? ""));
  nextParams.set("superProvider", String(game?.superProviderName ?? game?.super_provider_name ?? ""));
  nextParams.set("gameName", String(game?.gameName ?? game?.game_name ?? ""));
  nextParams.set("category", categoryForLaunch);
  navigate({
    pathname: `/dc/gamev1.1/${slug}`,
    search: nextParams.toString() ? `?${nextParams.toString()}` : "",
  });
}
